import type { ReactNode } from "react";

interface LegalSectionProps {
  id?: string;
  title: string;
  children: ReactNode;
}

/**
 * Bloque de contenido legal reutilizable: título de sección (h2) con ancla
 * y cuerpo con espaciado de línea amplio para máxima legibilidad.
 */
export default function LegalSection({ id, title, children }: LegalSectionProps) {
  return (
    <section id={id} className="mb-10 last:mb-0">
      <h2 className="font-heading text-lg font-semibold text-foreground-950 md:text-xl">
        {title}
      </h2>
      <div className="mt-4 space-y-4 text-sm leading-7 text-foreground-700 md:text-[15px] md:leading-8">
        {children}
      </div>
    </section>
  );
}